if (!customElements.get("m-product-review-gallery")) {
  class MProductReviewGallery extends HTMLElement {
    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      const swiperContainer = this.querySelector(".swiper-container");
      if (!swiperContainer) return;

      const autoplay = this.dataset.autoplay === "true";
      const timeout = parseInt(this.dataset.timeout, 10) || 5000;

      this.slider = new MinimogLibs.Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: autoplay
          ? { delay: timeout, disableOnInteraction: true }
          : false,
        navigation: {
          nextEl: this.querySelector(".m-product-review-gallery__nav--next"),
          prevEl: this.querySelector(".m-product-review-gallery__nav--prev"),
        },
      });
    }
  }

  customElements.define("m-product-review-gallery", MProductReviewGallery);
}
